import React from 'react'
import { flags } from 'config'
import DebugControls from './DebugControls'
import { DebugFeatures } from './useDebugFeatures'

/**
 * Component for rendering debug controls
 * Only renders when in development mode
 */
const DebugPanel: React.FC<{ debugFeatures: DebugFeatures }> = ({
    debugFeatures,
}) => {
    if (!flags.isDevelopment) return null

    return (
        <DebugControls
            simulatedResponse={debugFeatures.simulatedResponse}
            setSimulatedResponse={debugFeatures.setSimulatedResponse}
            simulateDonation={debugFeatures.handleSimulateDonation}
            resetForm={debugFeatures.resetForm}
            debugValues={debugFeatures.debugValues}
            onSimulateCharacters={debugFeatures.handleSimulateCharacters}
        />
    )
}

export default DebugPanel
